import { Supplier } from 'src/app/services/supplier.service';

const INVALID_SUPPLIERS_FORMAT =
  'Informe clientId:name separados por ; (ex: 123:Fornecedor A;456:Fornecedor B).';

/**
 * Parses the batch `suppliers` cell (`clientId:name` separated by `;`) into
 * `{ clientId, name }[]`. Empty cell returns `null` (caller clears).
 * Throws on invalid tokens.
 */
export function parseBatchSuppliers(
  raw: string | null | undefined
): Supplier[] | null {
  if (raw === '' || raw === null || raw === undefined) {
    return null;
  }

  const tokens = String(raw)
    .split(';')
    .map((token) => token.trim())
    .filter(Boolean);

  const resolved: Supplier[] = [];
  for (const token of tokens) {
    const separatorIndex = token.indexOf(':');
    if (separatorIndex <= 0) {
      throw new Error(INVALID_SUPPLIERS_FORMAT);
    }

    const clientIdRaw = token.slice(0, separatorIndex).trim();
    const name = token.slice(separatorIndex + 1).trim();
    const clientId = Number(clientIdRaw);

    if (!Number.isInteger(clientId) || !name) {
      throw new Error(INVALID_SUPPLIERS_FORMAT);
    }

    if (resolved.some((s) => s.clientId === clientId)) {
      continue;
    }

    resolved.push({ clientId, name });
  }

  return resolved;
}
